import { useEffect, useLayoutEffect, useRef } from 'react';

export const PreserveScroll = (key: string) => {
  const containerRef = useRef<HTMLElement>(undefined);
  const scrollPosition = useRef<number>(Number(sessionStorage.getItem(key) ?? 0));

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const handleScroll = () => {
      const top = el.scrollTop;
      scrollPosition.current = top;
      sessionStorage.setItem(key, String(top));
    };

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [key]);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    requestAnimationFrame(() => {
      el.scrollTop = scrollPosition.current;
    });
  });

  return containerRef;
};
